type SessionEventHandler = () => void;

let unauthorizedHandler: SessionEventHandler | null = null;
let forbiddenHandler: SessionEventHandler | null = null;

export const authSessionEvents = {
  onUnauthorized(handler: SessionEventHandler): void {
    unauthorizedHandler = handler;
  },
  onForbidden(handler: SessionEventHandler): void {
    forbiddenHandler = handler;
  },
  emitUnauthorized(): void {
    unauthorizedHandler?.();
  },
  emitForbidden(): void {
    forbiddenHandler?.();
  },
};
